<template>
  <ul class="flex gap-x-8" :class="dark ? 'text-white' : 'text-slate-lighten4'">
    <li v-for="item in items" :key="item.name">
      <UiLink
        :aria-label="`Open a social network ${item.name}`"
        :to="item.src"
        target="_blank"
      >
        <UiIcon :icon="item.name" class="h-6 w-6"></UiIcon>
      </UiLink>
    </li>
  </ul>
</template>

<script setup lang="ts">
interface Props {
  items?: any[];
  dark?: boolean;
}
withDefaults(defineProps<Props>(), {
  items: () => [],
  dark: false,
});
</script>
